import React from "react";
import ApplicationProvider from "pages/application-provider";
import { Button, Flex, Text, rem, SimpleGrid, Title, Box } from "@mantine/core";
import CarouselOp from "components/login/CarouselOp";

interface Props {
    staticBaseUrl: string;
}

export default function PasswordChangeDonePage(props: Props) {
    return (
        <ApplicationProvider>
            <Flex direction='column' w={'100svw'} h={'100svh'} p={rem(16)}>
                <SimpleGrid cols={2} h={'100%'}>
                    <Flex direction={'column'} p={rem(40)} justify={'center'}>
                        <Box maw={rem(262)} pos={'absolute'} top={rem(56)} component={'a'} href={'/'}>
                            <img src={`${props.staticBaseUrl}alone/images/logo-big.svg`} alt="Alone"/>
                        </Box>

                        <Flex direction={'column'} gap={rem(24)} maw={rem(400)}>
                            <Flex direction={'column'} gap={rem(16)}>
                                <Title fw={600} fz={rem(32)} c={'#1E1E1E'}>
                                    Password Changed! ✅
                                </Title>
                                <Title fw={500} fz={rem(18)} c={'#A3A3A3'}>
                                    Your password has been updated successfully.
                                </Title>
                            </Flex>

                            <Button
                                component="a"
                                href="/"
                                variant={'filled'}
                                bg={'#4B49AC'}
                                p={rem(16)}
                                style={{borderRadius: '12px'}}
                                h={rem(56)}
                                w={'100%'}
                                mt={rem(24)}
                            >
                                <Text c={'#FFFFFF'} fz={rem(16)} fw={500}>
                                    Return to Home
                                </Text>
                            </Button>
                        </Flex>
                    </Flex>
                    <CarouselOp staticBaseUrl={props.staticBaseUrl}/>
                </SimpleGrid>
            </Flex>
        </ApplicationProvider>
    );
}